var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { PutObjectCommand } from "@aws-sdk/client-s3";
import Base from './base';
import { S3ClientHttpRequestHandler } from "../utils/S3ClientHttpRequestHandler";
import { createXHR } from "../utils";
import { QiniuError, QiniuErrorName } from "../errors";

var Direct =
/** @class */
function (_super) {
  __extends(Direct, _super);

  function Direct() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Direct.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      var xhr, requestHandler, res, metadata;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logger.info('start run Direct.');
            xhr = createXHR();
            requestHandler = new S3ClientHttpRequestHandler(xhr);
            this.addXhr(xhr);
            requestHandler.onProgress$.subscribe(function (progress) {
              _this.updateDirectProgress(progress.progressEvent.loaded, progress.progressEvent.total);
            });
            this.s3Client.config.requestHandler = requestHandler;
            return [4
            /*yield*/
            , this.s3Client.send(new PutObjectCommand({
              Body: this.file,
              Bucket: this.bucketName,
              Key: this.key
            }))];

          case 1:
            res = _a.sent();
            metadata = res.$metadata;

            if (metadata && metadata.httpStatusCode != 200) {
              throw new QiniuError(QiniuErrorName.RequestError, '上传文件失败');
            }

            this.logger.info('Direct progress finish.');
            this.finishDirectProgress();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Direct.prototype.updateDirectProgress = function (loaded, total) {
    // 当请求未完成时可能进度会达到100，所以total + 1来防止这种情况出现
    this.progress = {
      total: this.getProgressInfoItem(loaded, total + 1)
    };
    this.onData(this.progress);
  };

  Direct.prototype.finishDirectProgress = function () {
    // 在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null，这里 fake 下
    if (!this.progress) {
      this.logger.warn('progress is null.');
      this.progress = {
        total: this.getProgressInfoItem(this.file.size, this.file.size)
      };
      this.onData(this.progress);
      return;
    }

    var total = this.progress.total;
    this.progress = {
      total: this.getProgressInfoItem(total.loaded + 1, total.size)
    };
    this.onData(this.progress);
  };

  return Direct;
}(Base);

export default Direct;